const PublicRoute = ({ element }) => {
  return element;
};

export default PublicRoute;
